import features from '../../../shared/features'

export function activityWatcher(onActivity: (name?: string) => void) {
  const onMouse = () => onActivity('mouse')
  const onKeyboard = () => onActivity('keyboard')
  const onScroll = () => onActivity('scroll')
  const onTouch = () => onActivity('touch')

  const handlerOptions = features().events.passiveSupported
    ? { passive: true, capture: true }
    : true

  setTimeout(() => {
    window.addEventListener('click', onMouse, handlerOptions)
    window.addEventListener('mousemove', onMouse, handlerOptions)
    window.addEventListener('mouseenter', onMouse, handlerOptions)
    window.addEventListener('mousewheel', onMouse, handlerOptions)
    window.addEventListener('keydown', onKeyboard, handlerOptions)
    window.addEventListener('scroll', onScroll, handlerOptions) // use from scroll watcher ?
    window.addEventListener('touchmove', onTouch, handlerOptions)
    window.addEventListener('touchstart', onTouch, handlerOptions)
  }, 100)
}
